import { RouteConfig } from "vue-router";

const mapeoGastos: RouteConfig = {
  path: "/mapeoGastos",
  name: "mapeoGastos",
  component: () => import(/* webpackChunkName: "mapeo-gastos" */ "@/views/MapeoGastos.vue"),
};

export default mapeoGastos;
